import { AppTFunction } from './types';

export const getTimeFormat = (t: AppTFunction): string => t('timeFormat');
